function layoutV21Assign() {
    // console.log($("#layout-section-1 .carouselContainer"));
    CarouselModule.initCarousel($("#layout-section-1 .carouselContainer"));
    updateIconsForTheme(document.documentElement.getAttribute("theme") || "light");
}
function layoutV22Assign() {
    lazyImages = $(".lazy-load");
    lazyImages.each(function () {
        const img = $(this);
        img.attr("src", img.data("src"));
        img.on("load", function () {
            img.parent().removeClass("lazy-load-wrapper");
            img.removeClass("lazy-load");
            // img.parent().removeClass("lazy-load-wrapper");
            // img.removeClass("lazy-load");
        });
    });
    updateIconsForTheme(document.documentElement.getAttribute("theme") || "light");
}
function layoutV23Assign() {
    lazyImages = $(".lazy-load");
    lazyImages.each(function () {
        const img = $(this);
        img.attr("src", img.data("src"));
        img.on("load", function () {
            img.parent().removeClass("lazy-load-wrapper");
            img.removeClass("lazy-load");
        });
    });
    updateIconsForTheme(document.documentElement.getAttribute("theme") || "light");
}
function layoutV24Assign() {
    lazyImages = $(".lazy-load");
    lazyImages.each(function () {
        const img = $(this);
        img.attr("src", img.data("src"));
        img.on("load", function () {
            img.parent().removeClass("lazy-load-wrapper");
            img.removeClass("lazy-load");
        });
    });
    updateIconsForTheme(document.documentElement.getAttribute("theme") || "light");
}

function checkMultipleDetails(form) {
    var frequencyMap = {};
    $.each(form, function (index, item) {
        var name = item.name;
        frequencyMap[name] = (frequencyMap[name] || 0) + 1;
    });

    // Extract names with frequency greater than 1
    var repeatedNames = [];
    for (var name in frequencyMap) {
        if (frequencyMap.hasOwnProperty(name) && frequencyMap[name] > 1) {
            repeatedNames.push(name);
        }
    }

    return repeatedNames;
}

function generateFormData(param) {
    var dataArr = $(param).serializeArray();
    var mutipleValue = checkMultipleDetails(dataArr);
    var formData = new FormData();
    $.each(dataArr, function (i, field) {
        if ($.inArray(field.name, mutipleValue) !== -1) {
        } else {
            formData.append(field.name, field.value);
        }
    });
    $.each(mutipleValue, function (index, value) {
        $.each(dataArr, function (i, field) {
            if (field.name == value) {
                formData.append(
                    field.name.replace("[]", "") + "[]",
                    field.value
                );
            }
        });
    });
    $.each(
        $(param).find('input[type="file"]:not([multiple])'),
        function (i, field) {
            formData.append(
                field.name,
                $(field)[0].files[0] != undefined ? $(field)[0].files[0] : ""
            );
        }
    );
    $.each($(param).find('input[type="file"][multiple]'), function (i, field) {
        var fileInput = $(field)[0];
        var files = fileInput.files;
        for (var i = 0; i < files.length; i++) {
            formData.append(field.name.replace("[]", "") + "[]", files[i]);
        }
        // formData.append(field.name + "[]", (($(field)[0].files[0]) != undefined) ? $(field)[0].files[0] : "");
    });

    return formData;
}

async function ajaxDynamicMethod(url, method, formData = "", formElement = "", isLoader = true) {
    if (isLoader) {
        $("#lds-roller").show();
    }
    const response = await $.ajax({
        type: method,
        url: url,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (data) {
            $(".errors").text("");
            if (data.error) {
                if (data.errors.length == "0" && data.msg) {
                    toastrerror(data.msg);
                } else {
                    for (const [key, value] of Object.entries(data.errors)) {
                        if (formElement != "") {
                            formElement.find("#" + key + "error").text(value);
                        }
                        else {
                            $("form[action='" + url + "']").find("#" + key + "error").text(value)
                        }
                        // $("#" + key + "error").text(value);
                        console.log("123", $("#" + key + "error").text(value));
                    }

                    if (data.sweeterror) {
                        var errorHTML = "<ul>";
                        for (const [key, value] of Object.entries(
                            data.errors
                        )) {
                            errorHTML += `<li><b>${ucwords(
                                key.replace("_", " ")
                            )} : </b>${value}</li>`;
                        }
                        errorHTML += "</ul>";

                        Swal.fire({
                            title: "Error",
                            html: errorHTML,
                            icon: "error",
                        });
                    }
                }
            } else if (data.success && data.route) {
                if (data.socket_trigger && socket) {
                    if (
                        typeof data.socket_trigger == "object" ||
                        typeof data.socket_trigger == "array"
                    ) {
                        data.socket_trigger.forEach((element) => {
                            console.log(element);
                            socket.emit("updatesection", {
                                page: "home",
                                layout_id: element,
                            });
                        });
                    }
                }
                window.location.href = data.route;
            }
        },
        error: function (request, status, error) {
            if (request.status == "500" || request.status == "405") {
                toastrerror(error);
                $("#lds-roller").hide();
            }
            else if (request.status == "401") {
                // handleUnauthorizedResponse();
            }
            else if (request.status == "429") {
                let errorResponse = JSON.parse(request.responseText);
                console.log(errorResponse.errors);
                if (errorResponse.errors.length == "0" && (errorResponse.msg || errorResponse.message)) {
                    toastrerror((errorResponse.msg) ? errorResponse.msg : errorResponse.message);
                } else {
                    for (const [key, value] of Object.entries(errorResponse.errors)) {
                        if (formElement != "") {
                            formElement.find("#" + key + "error").text(value);
                        }
                        else {
                            $("form[action='" + url + "']").find("#" + key + "error").text(value)
                        }
                    }
                }
                $("#lds-roller").hide();
                // toastrerror(error);
                // if (condition) {

                // }
                // handleUnauthorizedResponse();
            }
        },
    });
    $("#lds-roller").hide();
    return response;
}

async function getFooterDetails() {
    var data = await ajaxDynamicMethod(
        "/after-load",
        "GET", "", "", false
    );

    if (data.success) {
        $("#footerPopularCategories").html(data.data.footer_popular);
        $("#weeklyTrendingArticles").html(data.data.footer_trending_articles);
        $("#editorsTopPic").html(data.data.footer_editors_top_pic);
        applyTimeAgoFormatting();
    }
}

async function getHeaderDetails() {
    var data = await ajaxDynamicMethod(
        "/after-load-header",
        "GET", "", "", false
    );

    if (data.success) {
        $("#navPodCasts").html(data.data.menu_podcasts);
        $.each(data.data.final_menu_categories_for_header_ajex, function (key, html) {
            $("#" + key).html(html);
        });

        await getFooterDetails();
    }
}

function loadGoogleAnalytics() {
    if (window.gaLoaded) return;
    window.gaLoaded = true;
    var script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16458723024";
    script.async = true;
    document.head.appendChild(script);
    script.onload = function () {
        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'AW-16458723024');
    };
}

$(document).ready(async function () {
    let consent = localStorage.getItem("dhn_cookie_consent");
    if (!consent) {
        $.dhnPopup.open({
            popupId: "#dhn-cookie-popup",
            backdropId: "#dhn-cookie-popup-backdrop",
            position: "bottom-left",
            animation: "zoom-in",
            hasBackdrop: true,
            showOnce: "none",
            localStorageKey: "dhn_cookie_consent",
            delay: 0,
        });
    }
    if (consent === "accepted") {
        loadGoogleAnalytics();
    }
    setTimeout(async () => {
        await getHeaderDetails();
    }, 3000);
});

$(document).on("click", "#open-cookie-settings", function () {
    $.dhnPopup.open({
        popupId: "#dhn-cookie-popup",
        backdropId: "#dhn-cookie-popup-backdrop",
        position: "bottom-left",
        animation: "zoom-in",
        hasBackdrop: true,
        showOnce: "none",
        localStorageKey: "dhn_cookie_consent",
        delay: 0,
    });
});
$(document).on("click", ".btn-accept", function () {
    localStorage.setItem("dhn_cookie_consent", "accepted");
    $.dhnPopup.close({
        popupId: "#dhn-cookie-popup",
        backdropId: "#dhn-cookie-popup-backdrop",
    });
    loadGoogleAnalytics();
});
$(document).on("click", ".btn-reject", function () {
    localStorage.setItem("dhn_cookie_consent", "rejected");
    $.dhnPopup.close({
        popupId: "#dhn-cookie-popup",
        backdropId: "#dhn-cookie-popup-backdrop",
    });
});

$(".subMenuCategories li").mouseover(function () {
    var hoverId = this.id;
    var hoverClass = "." + hoverId;
    var hoverClass1 = "#" + hoverId;
    $(hoverClass1).addClass("active").siblings().removeClass("active");
    $(hoverClass).addClass("active").siblings().removeClass("active");
});

function loadLazyImages() {
    lazyImages = $(".lazy-load");
    lazyImages.each(function () {
        const img = $(this);
        img.attr("src", img.data("src"));
        img.on("load", function () {
            img.parent().removeClass("lazy-load-wrapper");
            img.removeClass("lazy-load");
        });
    });
}

// $(document).ready(function () {
//     console.log("[like-dislike-btn.js] Loaded.");

//     const $likeBtn = $("#likeBtn");
//     const $dislikeBtn = $("#dislikeBtn");

//     let isLiked = false;
//     let isDisliked = false;
//     let likeCount = 0;

//     let $likeIcon = null;
//     let $reactionCountSpan = null;
//     let $dislikeIcon = null;

//     // ------------------------------
//     // 1. READ FROM LOCALSTORAGE (once)
//     // ------------------------------
//     const storedCount = localStorage.getItem("likeCount");
//     const storedLikeState = localStorage.getItem("likeState");
//     const storedDislikeState = localStorage.getItem("dislikeState");

//     if (storedCount !== null) {
//         likeCount = parseInt(storedCount, 10) || 0;
//     }
//     if (storedLikeState === "true") {
//         isLiked = true;
//     }
//     if (storedDislikeState === "true") {
//         isDisliked = true;
//     }

//     // ------------------------------
//     // LIKE BUTTON SETUP
//     // ------------------------------
//     if ($likeBtn.length) {
//         console.log("[likeBtn] Found in DOM.");

//         $likeIcon = $likeBtn.find("img[data-icon]");
//         $reactionCountSpan = $likeBtn.find(".reaction-count");

//         if ($reactionCountSpan.length) {
//             const domCount = parseInt($reactionCountSpan.text() || "0", 10);
//             if (storedCount === null) {
//                 likeCount = domCount;
//             }
//         }

//         $likeBtn.on("click", function () {
//             console.log("[likeBtn] clicked. wasLiked?", isLiked);
//             const newLikeState = !isLiked;

//             if (newLikeState) {
//                 likeCount++;
//             } else {
//                 likeCount--;
//             }

//             let newDislikeState = isDisliked;
//             if (newLikeState && isDisliked) {
//                 newDislikeState = false;
//             }

//             isLiked = newLikeState;
//             isDisliked = newDislikeState;

//             persistStates(isLiked, isDisliked, likeCount);
//             updateUI(isLiked, isDisliked, likeCount);
//         });
//     }

//     // ------------------------------
//     // DISLIKE BUTTON SETUP
//     // ------------------------------
//     if ($dislikeBtn.length) {
//         console.log("[dislikeBtn] Found in DOM.");

//         $dislikeIcon = $dislikeBtn.find("img[data-icon]");

//         $dislikeBtn.on("click", function () {
//             console.log("[dislikeBtn] clicked. wasDisliked?", isDisliked);
//             const newDislikeState = !isDisliked;
//             let newLikeState = isLiked;
//             let newCount = likeCount;

//             if (newDislikeState && isLiked) {
//                 newLikeState = false;
//                 newCount = likeCount - 1;
//             }

//             isLiked = newLikeState;
//             isDisliked = newDislikeState;
//             likeCount = newCount;

//             persistStates(isLiked, isDisliked, likeCount);
//             updateUI(isLiked, isDisliked, likeCount);
//         });
//     }

//     // ------------------------------
//     // INITIAL UI UPDATE
//     // ------------------------------
//     updateUI(isLiked, isDisliked, likeCount);

//     function updateUI(liked, disliked, count) {
//         console.log("[like-dislike-btn] updateUI =>", { liked, disliked, count });

//         if ($likeBtn.length) {
//             if ($reactionCountSpan.length) {
//                 $reactionCountSpan.text(count);
//                 $reactionCountSpan.css("display", count > 0 ? "inline-block" : "none");
//             }

//             $likeBtn.toggleClass("active", liked);
//             $likeBtn.attr("aria-pressed", liked ? "true" : "false");

//             if ($likeIcon.length) {
//                 if (liked) {
//                     console.log("  => Setting data-force-theme=dark on likeIcon");
//                     $likeIcon.attr("data-force-theme", "dark");
//                 } else {
//                     console.log("  => Removing data-force-theme from likeIcon");
//                     $likeIcon.removeAttr("data-force-theme");
//                 }

//                 if (typeof window.applyTheme === "function") {
//                     window.applyTheme();
//                 }
//             }
//         }

//         if ($dislikeBtn.length) {
//             $dislikeBtn.toggleClass("active", disliked);
//             $dislikeBtn.attr("aria-pressed", disliked ? "true" : "false");

//             if ($dislikeIcon.length) {
//                 if (disliked) {
//                     console.log("  => Setting data-force-theme=dark on dislikeIcon");
//                     $dislikeIcon.attr("data-force-theme", "dark");
//                 } else {
//                     console.log("  => Removing data-force-theme from dislikeIcon");
//                     $dislikeIcon.removeAttr("data-force-theme");
//                 }

//                 if (typeof window.applyTheme === "function") {
//                     window.applyTheme();
//                 }
//             }
//         }
//     }

//     function persistStates(liked, disliked, count) {
//         localStorage.setItem("likeCount", String(count));
//         localStorage.setItem("likeState", String(liked));
//         localStorage.setItem("dislikeState", String(disliked));
//         console.log("[persistStates]", { liked, disliked, count });
//     }
// });


$(document).ready(function () {
    const $items = $(".flash-item");
    let current = 0;

    function cycleItems() {
        $items.eq(current).removeClass("active");
        current = (current + 1) % $items.length;
        $items.eq(current).addClass("active");
    }

    setInterval(cycleItems, 2500); // every 2.5 seconds
});

$(document).on("click", ".humbugMenu", function () {
    $(".mobileMenuExpandable").addClass("show");
});

$(document).on("click", ".humbugMenuClose", function () {
    $(".mobileMenuExpandable").removeClass("show");
});

$(document).on("click", ".mobileMenu__item", function (e) {
    /* ① element references */
    const $item = $(this); // <li>
    const $submenu = $item.children(".mobileSubMenu"); // nested <ul>

    if (!$submenu.length) return; // plain list item

    e.stopPropagation(); // keep event local

    /* ② close any other open menu */
    $(".mobileMenu__item.open")
        .not($item)
        .each(function () {
            $(this)
                .removeClass("open")
                .attr("aria-expanded", "false")
                .children(".mobileSubMenu")
                .slideUp(250)
                .end()
                .find("[data-icon]")
                .attr("data-icon", "general/plus-square.svg");
        });

    /* ③ toggle clicked submenu */
    const isOpening = !$item.hasClass("open");

    $item
        .toggleClass("open")
        .attr("aria-expanded", isOpening)
        .children(".mobileSubMenu")
        .slideToggle(250)
        .end()
        .find("[data-icon]")
        .attr(
            "data-icon",
            isOpening ? "general/minus-square.svg" : "general/plus-square.svg"
        );

    /* ④ tell your theme-aware helper to refresh <img src="…"> */
    if (typeof window.updateIconsForTheme === "function") {
        const pageTheme =
            window.forceTheme ||
            document.documentElement.getAttribute("theme") ||
            "light";
        window.updateIconsForTheme(pageTheme);
    }
});


// Shared submit handler
async function handleSubscriberFormSubmit(e, formId) {
    e.preventDefault();

    const form = $(formId)[0];
    const action = $(form).attr('action');
    const method = $(form).attr('method');

    // Get reCAPTCHA response
    const captchaResponse = grecaptcha.getResponse();
    if (!captchaResponse) {
        $(form).find('#g-recaptcha-responseerror').text("Please verify that you're not a robot.");
        return;
    } else {
        $(form).find('#g-recaptcha-responseerror').text(""); // Clear any previous error
    }

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', captchaResponse);

    const data = await ajaxDynamicMethod(action, method, formData);

    // Reset reCAPTCHA
    grecaptcha.reset();

    if (data.success) {
        toastrsuccess(data.msg);
        form.reset();
        if (formId === "#subscriber-form") {
            $('.dhn-close-btn').click(); // Modal-specific logic
        }
    } else {
        // Show error if recaptcha failed from backend
        if (data.errors && data.errors['captcha']) {
            $(form).find('#g-recaptcha-responseerror').text(data.errors['captcha']);
        }
    }
}

// Attach handlers
$(document).on("submit", "#subscriber-form", function (e) {
    handleSubscriberFormSubmit(e, "#subscriber-form");
});

$(document).on("submit", "#foter-subscriber-form", function (e) {
    handleSubscriberFormSubmit(e, "#foter-subscriber-form");
});


$(document).on("click", ".TopTabSection button", async function (e) {
    $(".tabContent").removeClass('tabShow');
    $(".tabContent." + $(this).data("target")).addClass("tabShow");
    $(".TopTabSection button").removeClass("active");
    $('[data-target="' + $(this).data("target") + '"]').addClass('active');
});


$(document).on('click', "#likeBtn", async function () {
    var formData = new FormData();
    formData.append("postId", $(this).data('id'));
    formData.append("button", $(this).data('status'));
    formData.append("isPressed", $(this).attr('aria-pressed'));
    formData.append("isdislikePressed", $("#dislikeBtn").attr('aria-pressed'));
    await ajaxDynamicMethod($(this).data('action'), "POST",
        formData);
});

$(document).on('click', "#dislikeBtn", async function () {
    var formData = new FormData();
    formData.append("postId", $(this).data('id'));
    formData.append("button", $(this).data('status'));
    formData.append("isPressed", $(this).attr('aria-pressed'));
    formData.append("islikePressed", $("#dislikeBtn").attr('aria-pressed'));
    await ajaxDynamicMethod($(this).data('action'), "POST",
        formData);
});


function formatAmount(decimalNumber) {
    var formatted = decimalNumber.toFixed(2);
    var parts = formatted.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to the integer part
    return parts.join(".");
}

function alltime() {
    toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
}

function toastrsuccess(msg) {
    alltime();
    Command: toastr["success"](msg);
}

function toastrerror(msg) {
    alltime();
    Command: toastr["error"](msg);
}

function toastrinfo(msg) {
    toastr.options = {
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "0",
        "hideDuration": "0",
        "timeOut": "0",
        "extendedTimeOut": "0",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
    }
    Command: toastr["info"](msg);
}


$(document).ready(function () {
    const $btn = $(".btn-toggle-audio"); // Target the first eligible button
    const audio = document.getElementById("articleAudio");
    let isPlaying = false;
    if (!$btn.length || $btn.attr("id") === "likeBtn" || $btn.attr("id") === "dislikeBtn") {
        console.log("[toggle-buttons] Skipping:", $btn.attr("id"));
        return;
    }
    const lsKey = $btn.data("lskey") || null;
    const themeToggleAttr = $btn.data("theme-toggle");
    const forceThemeWhenActive = themeToggleAttr === "dark";
    let isActive = false;
    // 1) READ FROM LOCALSTORAGE
    if (lsKey) {
        const storedVal = localStorage.getItem(lsKey);
        if (storedVal === "true") {
            $btn.addClass("active").attr("aria-pressed", "true");
            isActive = true;
            isPlaying = true;
        }
    }
    // 2) APPLY ICON & THEME BASED ON INITIAL STATE
    applyIconToggleAudio($btn, isActive, forceThemeWhenActive);
    // 3) CLICK LISTENER
    $btn.on("click", function () {
        isPlaying = !isPlaying;
        $btn.toggleClass("active", isPlaying)
            .attr("aria-pressed", isPlaying ? "true" : "false");
        if (isPlaying) {
            audio.play();
        } else {
            audio.pause();
        }
        applyIconToggleAudio($btn, isPlaying, forceThemeWhenActive);
        if (lsKey) {
            localStorage.setItem(lsKey, String(newActiveState));
        }
    });
    audio.addEventListener("ended", function () {
        isPlaying = false;
        $btn.removeClass("active").attr("aria-pressed", "false");
        applyIconToggleAudio($btn, false, forceThemeWhenActive);
        if (lsKey) {
            localStorage.setItem(lsKey, "false");
        }
    });
    function applyIconToggleAudio($button, isActive, forceThemeWhenActive) {
        const $iconEl = $button.find("img[data-icon][data-toggled-icon]");
        if (!$iconEl.length) return;
        if (!$iconEl.data("icon-off")) {
            $iconEl.data("icon-off", $iconEl.attr("data-icon") || "");
        }
        const toggledIcon = $iconEl.attr("data-toggled-icon");
        const newIcon = isActive ? toggledIcon : $iconEl.data("icon-off");
        $iconEl.attr("data-icon", newIcon);
        if (forceThemeWhenActive) {
            if (isActive) {
                $iconEl.attr("data-force-theme", "dark");
            } else {
                $iconEl.removeAttr("data-force-theme");
            }
        }
        if ($iconEl.is("img")) {
            $iconEl.attr("src", newIcon);
        }
        if (typeof window.applyTheme === "function") {
            window.applyTheme();
        }
    }
});

$(document).on("click", ".float-close", function () {
    $(".side-sticky-box").remove();
});

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 400) {
        $(".side-sticky-box").fadeIn("slow");
    }
});


document.addEventListener("DOMContentLoaded", function () {
    const containers = document.querySelectorAll(".chatBotFabLottie");
    if (containers.length && window.lottie) {
        containers.forEach(container => {
            lottie.loadAnimation({
                container: container,
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/assets/front-v2/lottie/chatbot.json"
            });
        });
    }
    const dotscontainers = document.querySelectorAll(".chatThinkingLottie");
    if (dotscontainers.length && window.lottie) {
        dotscontainers.forEach(container => {
            lottie.loadAnimation({
                container: container,
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/assets/front-v2/lottie/dots.json"
            });
        });
    }
});

$(document).on("click", ".chatWindow .chatWindow-closeBtn", function () {
    $(".chatWindow").removeClass("show");
});
$(document).on("click", ".chatBotFab", function () {
    if ($(".chatWindow").hasClass("show")) {
        $(".chatWindow").removeClass("show");
    }
    else {
        $(".chatWindow").addClass("show");
    }
});

async function sendMessage() {
    let message = $(".chatWindow-input").val().trim();
    if (message !== "") {
        let $input = $(".chatWindow-input");
        let $button = $(".chatWindow-sendBtn");
        $(".chatWindow-thinking").addClass("show");
        $input.val("");
        $input.prop("disabled", true);
        $button.prop("disabled", true);
        $(".chatWindow-messages").append(`<div class="chatWindow-message chatWindow-message-bot chatWindow-message-user">
                ${message}
            </div>`);
        $('.chatWindow-body').animate({
            scrollTop: $('.chatWindow-body')[0].scrollHeight
        }, 500);
        let formData = new FormData();
        formData.append("message", message);
        try {
            var data = await ajaxDynamicMethod($(".chatWindow-sendBtn").data('url'), "POST", formData, "", false);
            if (data.success) {
                $(".chatWindow-thinking").removeClass("show");
                $(".chatWindow-messages").append(`<div class="chatWindow-message chatWindow-message-bot">
                <img class="chatBotIcon" src="/assets/front-v2/images/chatbot.svg" width="32">
                ${data.data.response}
            </div>
                `);
                // $('.chatWindow-body').animate({
                //     scrollTop: $('.chatWindow-body')[0].scrollHeight
                // }, 500);
            }
        } catch (err) {
            console.error("Error:", err);
        } finally {
            $input.prop("disabled", false);
            $button.prop("disabled", false);
            $input.focus();
        }
    }
}

$(".chatWindow-sendBtn").on("click", async function () {
    await sendMessage();
});

$(".chatWindow-input").on("keypress", async function (e) {
    if (e.which === 13) {  // 13 = Enter key
        e.preventDefault(); // prevent form submit if inside <form>
        await sendMessage();
    }
});
